import { Pipe, PipeTransform } from '@angular/core';
import { BASE_URI } from '@config/global-constants';
@Pipe({
  name: 'xeaSourcePath',
  standalone: false,
})
export class SourcePathPipe implements PipeTransform {
  public transform(value: string): string {
    return value ? BASE_URI.concat(value) : value;
  }
}
